import React, { useId } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  DEFAULT_SALON_PUBLIC_THEME,
  SALON_FONT_CATALOG,
  SALON_FONT_KEYS,
} from '../../../theme/salonPublicTheme';


const SalonThemeCompactFontPicker = ({
  value,
  error = '',
  disabled = false,
  accentColor = DEFAULT_SALON_PUBLIC_THEME.primary_color,
  onChange,
  focusRef,
}) => {
  const { t, i18n } = useTranslation();
  const labelId = useId();
  const errorId = useId();
  const direction = typeof i18n.dir === 'function' && i18n.dir() === 'rtl'
    ? 'rtl'
    : 'ltr';
  const selectedPreset = SALON_FONT_CATALOG[value] || SALON_FONT_CATALOG.saloone;
  const selectedStack = selectedPreset[direction].join(', ');

  return (
    <FormControl fullWidth size="small" error={Boolean(error)} disabled={disabled}>
      <InputLabel id={labelId}>{t('salon_theme.fields.font_key')}</InputLabel>
      <Select
        labelId={labelId}
        label={t('salon_theme.fields.font_key')}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        inputRef={focusRef}
        inputProps={{
          'aria-label': t('salon_theme.fields.font_key'),
          'aria-describedby': error ? errorId : undefined,
        }}
        SelectDisplayProps={{
          'aria-invalid': Boolean(error),
          'aria-describedby': error ? errorId : undefined,
          style: { fontFamily: selectedStack },
        }}
        style={{ fontFamily: selectedStack }}
        sx={{
          '&:focus-visible': {
            outline: '3px solid',
            outlineColor: accentColor,
            outlineOffset: 2,
          },
        }}
      >
        {SALON_FONT_KEYS.map((fontKey) => {
          const preset = SALON_FONT_CATALOG[fontKey];
          const stack = preset[direction].join(', ');
          return (
            <MenuItem key={fontKey} value={fontKey}>
              <Stack spacing={0.25} style={{ fontFamily: stack }}>
                <Typography fontWeight={700}>{preset.label}</Typography>
                <Typography variant="caption">{t('salon_theme.font_picker.sample')}</Typography>
              </Stack>
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText id={errorId}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SalonThemeCompactFontPicker;
